import { isoString, systemClock, type Clock } from "../time.js";
import type { Task } from "./types.js";

export interface CompleteResult {
  completed: Task;
  /** Always null in the override-based model. Kept for back-compat shape. */
  next: null;
}

/**
 * Mark a task done. Recurring series progress through per-occurrence overrides
 * (status='done'), not by spawning chained child tasks — completing a single
 * occurrence is done via the overrides repository in the calendar store.
 */
export function completeTask(task: Task, _rule: unknown, now: Clock = systemClock): CompleteResult {
  const ts = isoString(now());
  return { completed: { ...task, status: "done", completed_at: ts, updated_at: ts }, next: null };
}

/** Reopen a done task: back to "open", completion timestamp cleared, `updated_at`
 *  bumped. The inverse of {@link completeTask} — keep them in sync. */
export function reopenTask(task: Task, now: Clock = systemClock): Task {
  const ts = isoString(now());
  return { ...task, status: "open", completed_at: null, updated_at: ts };
}
